module.exports = __webpack_public_path__ + "img/I-06234_93-e.835f4dfc.jpg";